import { FieldProps } from 'formik';
import * as React from 'react';
import ErrorTextField from './ErrorTextField';

interface FormFieldProps extends FieldProps {
	required?: boolean;
}

const WhyMk: React.StatelessComponent<FormFieldProps> = function (props) {
	const {
		form: { errors, touched },
		field,
		required,
	} = props;
	const name = field.name;

	return <ErrorTextField
		errorMessage={touched[name] ? errors[name] as string : undefined}
		label='Why is MK Decision the right fit for you?'
		required={required}
		multiline={true}
		rows={4}
		{...field}
	/>;
};

export default WhyMk;
